export type ChallengeIdeaFiltersState = {
  query: string;
  tags: string[];
  status: "submitted" | "draft" | "all";
  authorGroupIds: string[];
  labels: string[];
  authorOrganisationIds: string[];
  sort: string;
  sortDirection: "asc" | "desc";
  page: number;
  limit: number;
  fieldChoices: string[];
  assignees: ("me" | "unassigned" | string)[];
  lanes: string[];
  ideaViewType: "card" | "list" | "board";
  filtersVisible: boolean;
  hasAdminComment: "yes" | "no" | "all";
  hasCustomDeadline: "yes" | "no" | "all";
  impactIds: string[];
};

export type ChallengeIdeaFiltersAction =
  | {
      type: "UPDATE_CHALLENGE_IDEA_FILTERS";
      data: Partial<ChallengeIdeaFiltersState>;
    }
  | {
      type: "SET_CHALLENGE_IDEA_VIEW_TYPE";
      ideaViewType: ChallengeIdeaFiltersState["ideaViewType"];
    };

const initialState: ChallengeIdeaFiltersState = {
  query: "",
  tags: [],
  status: "all",
  authorGroupIds: [],
  labels: [],
  authorOrganisationIds: [],
  sort: "default",
  sortDirection: "desc",
  page: 1,
  limit: 16,
  fieldChoices: [],
  lanes: [],
  ideaViewType: "card",
  filtersVisible: false,
  hasAdminComment: "all",
  hasCustomDeadline: "all",
  assignees: [],
  impactIds: [],
};

export const defaultInitialState: ChallengeIdeaFiltersState = {
  ...initialState,
};

function challengeIdeaFilters(
  state = initialState,
  action: ChallengeIdeaFiltersAction,
): ChallengeIdeaFiltersState {
  switch (action.type) {
    case "UPDATE_CHALLENGE_IDEA_FILTERS":
      return { ...state, ...action.data };
    case "SET_CHALLENGE_IDEA_VIEW_TYPE": {
      // Opening an idea on the board re-applies this action via search
      // params; keep existing filters unless the view type actually changed.
      if (action.ideaViewType === state.ideaViewType) {
        return state;
      }
      return {
        ...state,
        ideaViewType: action.ideaViewType,
        limit: action.ideaViewType === "card" ? 16 : 30,
        status:
          action.ideaViewType === "board"
            ? "submitted"
            : state.ideaViewType === "board"
              ? "all"
              : state.status,
      };
    }
    default:
      return state;
  }
}

export default challengeIdeaFilters;
